import Axios from 'axios';
import config from '@/config/index';

export interface IAsLogin {
  username: string;
  password: string;
}
interface ITokenInfo {
  access_token: string;
  token_type: string;
  userName: string;
}

const asLoginRequest = Axios.create({
  baseURL: config.authUrl,
  headers: {
    Authorization: config.authCode,
  },
});
asLoginRequest.interceptors.response.use((response) => {
  return response.data;
}, (error) => {
  if (error.response) {
    // 发送请求后，服务端返回的响应码不是 2xx
    error.message = error.response.data.error_description;
  } else if (error.request) {
    // 发送请求但是没有响应返回
    error.message = 'Error,请求没有响应';
  }
  return Promise.reject(error);
});

export const asLogin = ({username, password}: IAsLogin): Promise<ITokenInfo> => {
  const data = `grant_type=password&username=${username}&password=${password}`;
  return asLoginRequest.post('', data);
};

// export default asLoginRequest;
